"use client";

import { TechnologySectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedTechnologySection from "../Components/GeneratedTechnologySection";

const Technology: FC<TechnologySectionProps> = (props) => {
  return <GeneratedTechnologySection {...props} />;
};

export default Technology;
